import PropTypes from 'prop-types';
import React, { Component } from 'react';
import useSheet from '../../jss';
import Button from '../../components/commons/Button';
import { fileToDataUrl } from '../../utils/fileUtils';

const propTypes = {
  onChange: PropTypes.func.isRequired,
  sheet: PropTypes.object.isRequired,
};

class ImageUploader extends Component {
  constructor(...args) {
    super(...args);
    this.state = {
      file: '',
      imagePreviewUrl: '',
    };
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit() {
    this.inputElement.click();
  }

  handleImageChange(event) {
    const { onChange } = this.props;
    const file = event.target.files[0];
    fileToDataUrl(file)
      .then(onChange)
      .catch((e) => {
        console.error('oh dear, problem with image upload', e);
      });
  }

  handleRef(ref) {
    this.inputElement = ref;
  }

  render() {
    const {
      sheet: { classes },
    } = this.props;

    return (
      <div className={classes.inputWrapper}>
        <input
          className={classes.inputField}
          ref={ref => this.handleRef(ref)}
          type="file"
          onChange={this.handleImageChange}
          accept="image/*"
        />
        <Button
          block
          onClick={this.handleSubmit}
          size="large"
        >
          Upload Image
        </Button>
      </div>
    );
  }
}

function applyStyles(theme) {
  return {
    inputField: {
      opacity: 0,
      position: 'absolute',
    },
    inputWrapper: {
      paddingTop: theme.spacing.small,
      paddingBottom: theme.spacing.small,
      position: 'relative',
    },
  };
}

ImageUploader.propTypes = propTypes;

export default useSheet(applyStyles)(ImageUploader);
